import { createContext } from 'react';

import type { AuthStatus, Session } from './types';

export interface AuthContextValue {
  status: AuthStatus;
  session: Session | null;
  /** Trwa logowanie albo wylogowanie — blokuje przyciski. */
  isBusy: boolean;
  /** Komunikat dla użytkownika, po polsku. */
  error: string | null;
  loginWithEkuria: () => Promise<void>;
  loginWithAccessToken: (token: string) => Promise<Session>;
  logout: () => Promise<void>;
  clearError: () => void;
  /** Z /config.json — pozwala ukryć ścieżkę logowania na danym środowisku. */
  oidcEnabled: boolean;
  tokenEnabled: boolean;
  providerName: string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export const SESSION_QUERY_KEY = ['auth', 'session'] as const;
